<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canDelete="isEditing" @delete="beforeDeleteRegistro" @add="novoRegistro" 
        :isSearch="true" @search="goSearch">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center>
                <v-flex class="item" xs12 md11 ma-5>
                    <h3><b>Dados do Princípio Ativo</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs8 md8 lg8>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmPrincipioAtivo" label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs3 md3 lg3>
                    <v-text-field
                        :rules="[campoObrigatorio, tamanhoMaximoTrinta]"
                        v-model.trim="registro.cdItem"
                        label="Código na empresa"
                        outlined
                        clearable
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @save="saveRegistro" @return="voltar" :canDelete="false"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, tamanhoMaximoTrinta } from '@/filters/rules'
import { TituloShouldNavigate,
        MensagemShouldNavigate,
        MensagemSuccessSave } from '@/resourceMessageFile.js'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

export default {
    name: 'PrincipioAtivo',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    data() {
        return{
            isFormValid: false,
            isEditing: false,
            isModified: false,
            registro: {},
            registroBanco: {},
            isLoading: false,
        }
    },
    computed: {
        tituloTela: {
            get() {
                if (this.isEditing)
                    return 'Princípio Ativo: ' + this.registro.idPrincipioAtivo

                return 'Inserindo novo Princípio Ativo'
            }
        },
    },
    methods: {
        campoObrigatorio,
        tamanhoMaximoTrinta,
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.isLoading = true
                if (this.$refs.form != undefined) 
                {
                    this.$refs.form.reset()
                }
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isEditing'){
                this.isLoading = true
                this.getRegistro(value)
                this.isEditing = true
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute(route) {
            if (route.params.id){
                this.changeViewState('isEditing', route.params.id)
            } else {
                this.changeViewState('isInserting', null)
            }
        },
        getRegistro (id) {
            this.$axios.get('principio-ativo/' + id)
            .then((response) => {
                var rec = response.data[0].data
                this.registro = Object.assign({}, rec)
                this.registroBanco = Object.assign({}, rec)
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
                this.$router.push({ path: '/principioAtivo'})
            })
        },
        saveRegistro() {
            if (this.$refs.form.validate())
            {
                if (this.isEditing)
                {
                    this.updateRegistro()
                }
                else
                {
                    this.insertRegistro()
                }
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.registro.dsPrincipioAtivo = this.registro.dsPrincipioAtivo == null ? '' : this.registro.dsPrincipioAtivo
            this.$axios.post('principio-ativo/', this.registro)
            .then((response) => {
                this.$router.replace({ name: 'principioAtivo', params: { id: response.data[0].data.idPrincipioAtivo }})
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadPrincipiosAtivos')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        updateRegistro() {
            this.changeViewState('isLoading')
            this.registro.dsPrincipioAtivo = this.registro.dsPrincipioAtivo == null ? '' : this.registro.dsPrincipioAtivo
            this.$axios.put('principio-ativo/' + this.registro.idPrincipioAtivo, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.initViewFromRoute(this.$route)
                this.$store.dispatch('actLoadPrincipiosAtivos')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        beforeDeleteRegistro() {
            this.$root.$confirm('Deseja Excluir?', 'O registro será excluído permanentemente.', { color: 'red', width: 400 })
            .then(confirm => {
                if (confirm)
                    this.deleteRegistro()
            })
        },
        deleteRegistro() {
            this.changeViewState('isLoading')
            this.$axios.delete('principio-ativo/' + this.registro.idPrincipioAtivo)
            .then(() => {
                this.$router.go(-1)
                this.changeViewState('endLoading')
                this.$store.dispatch('actLoadPrincipiosAtivos')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/principioAtivo' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                idPrincipioAtivo: 0,
                nmPrincipioAtivo: '',
                dsPrincipioAtivo: '',
                cdItem: ''
            }
            this.registroBanco = {
                idPrincipioAtivo: 0,
                nmPrincipioAtivo: '',
                dsPrincipioAtivo: '',
                cdItem: ''
            }
        },
        goSearch() {
            this.$router.push({ path: '/principioAtivoSearch' })
        },
        shouldNavigate(to, from, next) {
            if (JSON.stringify(this.registro) !== JSON.stringify(this.registroBanco) && !this.isLoading)
            {
                this.$root.$confirm(TituloShouldNavigate, MensagemShouldNavigate, { color: 'red', width: 400 })
                    .then(confirm => {
                        next(confirm)
                        return confirm
                    })
            }
            else
            {
                next()
                return true
            }
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute(this.$route)
    },
    beforeRouteUpdate(to, from, next){
        this.shouldNavigate(to, from, next)
    },
    beforeRouteLeave (to, from, next) {
        this.shouldNavigate(to, from, next)
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
    .marginTitle {
        margin: 15px;
    }
    .headerCard {
        color: white; 
        background: #04222D; 
        padding:10px;
    }
</style>
